import { render, staticRenderFns } from "./CourseBagItem.vue?vue&type=template&id=25f4ceab&scoped=true&"
import script from "./CourseBagItem.vue?vue&type=script&lang=js&"
export * from "./CourseBagItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseBagItem.vue?vue&type=style&index=0&id=25f4ceab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4ceab",
  null
  
)

export default component.exports